import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import { storeInstructions } from "../questionnaires";
import { useSelector } from "react-redux";
import { authSelector } from "../../../../../redux/slices/authSlice";

const style = {
  position: "relative",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "600px",
  height: "590px",
  overFlow: "hidden",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: "20px 50px",
  borderRadius: "20px",
};

export default function AddNewStoreModal({ closeModal, label = "Add Stores" }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const {loggedUser} = useSelector(authSelector)
  return (
    <>
      <Button
        variant="lightblue"
        sx={{
          background: "#210C43",
          margin: 0,
          boxShadow: "none",
          ":hover": {
            background: "#210C43",
          },
          width: "80%",
          margin: "auto",
        }}
        className="w-full"
        onClick={handleOpen}
        endIcon={<Add />}
      >
        {label}
      </Button>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
          // style:{
          //   pointerEvents:"none"
          // }
        }}
      >
        <Fade in={open} timeout={{ enter: 500, exit: 500 }}>
          <Box sx={style} className="">
            <h4 style={{ marginBottom: "20px" }}>Add a new store</h4>
            <p
              style={{
                lineHeight: 1.6,
                fontSize: "15px",
                marginBottom: "40px",
              }}
            >
              To access multiple stores from one login, you have to make sure,{" "}
              <span style={{ color: "#7F56D9" }}>{loggedUser?.user?.email}</span> gets added as a
              team member in your second account.{" "}
            </p>

            {storeInstructions(loggedUser?.user?.email)?.map((instruction) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  marginTop: "30px",
                }}
              >
                <div
                  style={{
                    padding: "4px 8px",
                    width: "50px",
                    height: "30px",
                    borderRadius: "5px",
                    background: "#d6c7f1",
                    marginRight: "20px",
                  }}
                >
                  <strong style={{ color: "#7F56D9" }}>
                    {instruction?.id+"."}
                  </strong>
                </div>
                <div style={{ textAlign: "left" }}>
                  <h5 style={{ fontSize: "18px" }}>{instruction?.title}</h5>
                  <p>{instruction?.desc}</p>
                </div>
              </div>
            ))}
            <Button
              variant="lightblue"
              sx={{
                background: "#210C43",
                marginBottom: 0,
                boxShadow: "none",
                ":hover": {
                  background: "#210C43",
                },
                width: "80%",
                marginTop: "50px",
              }}
              onClick={() =>{

                closeModal()
                handleClose()
              }}
              className="w-full"
            >
              Close
            </Button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
